import { a as u } from "./index-es.js";
const c = u.create({
  baseURL: "/apiproxy/v1"
});
async function f(e) {
  const {
    baseURL: o,
    rootOwner: n,
    folderId: t,
    sort: r,
    group: s,
    rootType: a,
    page: d
  } = e, l = "/mycontent", i = {
    crossDomain: !0,
    baseURL: o || "/apiproxy/v1",
    params: {
      root_owner: n || "user",
      folder_id: t || null,
      sort: r || null,
      group: s === "all" ? null : s || null,
      root_folder_type: a || null,
      page: d || null
    },
    withCredentials: !0
  };
  return (await c.get(l, i)).data;
}
async function _({
  baseURL: e,
  folderId: o,
  filename: n,
  contentType: t,
  token: r
}) {
  const s = "/mycontent/get_upload_url", a = {
    file_name: n,
    folder_id: o,
    content_type: t
  }, d = {
    baseURL: e || "/apiproxy/v1",
    headers: {
      "X-Token": r
    },
    withCredentials: !0
  };
  let l;
  try {
    l = await c.post(s, a, d);
  } catch (i) {
    l = i;
  }
  return l;
}
async function g(e = "", o) {
  const t = `/mycontent/folders?root_folder_type_id=2${e ? `&folder_id=${e}` : ""}&current_tab=${o}`;
  return (await c.get(t, {
    crossDomain: !0,
    withCredentials: !0
  })).data;
}
async function m({
  folderParentId: e,
  title: o,
  tab: n,
  token: t
}) {
  const r = "/mycontent/folder/add", s = {
    parent_folder_id: e,
    title: o,
    current_tab: n
  }, a = {
    headers: {
      "X-Token": t
    },
    withCredentials: !0
  };
  return (await c.post(r, s, a)).data;
}
async function w({
  assetId: e,
  tab: o,
  token: n
}) {
  const t = `/mycontent/folder/add/${e}?current_tab=${o}`, r = {
    headers: {
      "X-Token": n
    },
    withCredentials: !0
  };
  return (await c.post(t, {}, r)).data;
}
async function h({
  folderId: e,
  assetId: o,
  tab: n,
  token: t
}) {
  const r = `/mycontent/folder/${e}/add/${o}?current_tab=${n}`, s = {
    headers: {
      "X-Token": t
    },
    withCredentials: !0
  };
  return (await c.post(r, {}, s)).data;
}
async function T({
  folderId: e,
  bulkAssets: o,
  tab: n,
  token: t
}) {
  const r = `/mycontent/folder/${e}/add_many`, s = {
    current_tab: n,
    resource_ids: o
  }, a = {
    headers: {
      "X-Token": t
    },
    withCredentials: !0
  };
  return (await c.post(r, s, a)).data;
}
async function b({
  targetFolderId: e,
  assetId: o,
  tab: n,
  token: t
}) {
  const r = `/mycontent/folder/copy/${o}`, s = {
    current_tab: n,
    target_tab: n,
    target_folder_id: e === "root" ? null : e
  }, a = {
    headers: {
      "X-Token": t
    }
  };
  return (await c.post(r, s, a)).data;
}
async function $({
  targetFolderId: e,
  currentFolderId: o,
  assetId: n,
  tab: t,
  token: r
}) {
  const s = "/mycontent/folder/move", a = {
    current_tab: t,
    target_tab: t,
    current_folder_id: o,
    target_folder_id: e,
    resource_id: n
  }, d = {
    headers: {
      "X-Token": r
    }
  };
  return (await c.post(s, a, d)).data;
}
async function k(e, o, n, t) {
  const r = `/mycontent/folder/move/${o}/restore`, s = {
    headers: {
      "X-Token": t
    }
  }, a = {
    current_folder_id: e,
    current_tab: n
  };
  return await c.post(r, a, s);
}
async function C({
  assetId: e,
  currentFolderId: o,
  tab: n,
  token: t
}) {
  const r = `/mycontent/folder/move/${e}/trash`, s = {
    headers: {
      "X-Token": t
    }
  }, a = {
    current_folder_id: o,
    current_tab: n
  };
  return await c.post(r, a, s);
}
export {
  f as a,
  g as b,
  m as c,
  w as d,
  h as e,
  b as f,
  _ as g,
  C as h,
  c as i,
  T as j,
  $ as m,
  k as r
};
